import { render, staticRenderFns } from "./SpacerDividerWidget.vue?vue&type=template&id=46cbfb7a&"
import script from "./SpacerDividerWidget.vue?vue&type=script&lang=js&"
export * from "./SpacerDividerWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports